import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectChemicalMixField');

    return {
        CHEMICAL_MIX: t('chemicalMix'),
        CHEMICAL_MIX_IS_REQUIRED: t('chemicalMixIsRequired')
    };
};

export default useTranslation;
